import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@/components/ui/Carousel'
import { Divider } from '@/components/ui/Divider'
import { Container } from '@/components/ui/template/Container'
import { useWindowSize } from '@/hooks/helpers/useWindowSize'
import { CEXFundStat, StakedSupplyStat, TreasuryStat } from '@/components/pepper-stats/PepperStats'
import Autoplay from 'embla-carousel-autoplay'

const STATS = [TreasuryStat, StakedSupplyStat, CEXFundStat] as const

const STATS_WITH_DIVIDER = STATS.flatMap((stat, index) => {
	return index !== STATS.length - 1
		? [stat, () => <Divider variant="subtle" orientation="vertical" className="h-[140px] border-green-10" />]
		: [stat]
})

function MobileContent() {
	return (
		<Carousel opts={{ loop: true }} plugins={[Autoplay({ stopOnFocusIn: true })]}>
			<CarouselContent>
				{STATS.map((Stat, index) => (
					<CarouselItem key={index}>
						<Stat />
					</CarouselItem>
				))}
			</CarouselContent>
			<CarouselDots />
		</Carousel>
	)
}

export function PepperIncStatsSection() {
	const { isDesktop } = useWindowSize()

	return (
		<Container className="bg-primary">
			<Container.Content className="py-6 px-5 md:py-8 flex flex-col gap-8 lg:flex-row items-center justify-evenly">
				{isDesktop ? (
					STATS_WITH_DIVIDER.map((Stat, index) => <Stat className="flex-1" key={index} />)
				) : (
					<MobileContent />
				)}
			</Container.Content>
		</Container>
	)
}
